import type {
  KnownNotificationResource,
  NotificationResource,
  ProjectCommentNotificationResource,
  SocialOrderCommentNotificationResource,
} from '../../../api/notifications'
import {
  FallbackNotificationCard,
  FollowedAuthorProjectPublishedNotificationCard,
  FollowedAuthorProjectRecruitmentOpenedNotificationCard,
  FollowedAuthorProjectRecruitmentUpdatedNotificationCard,
  FollowedAuthorProjectStatusChangedNotificationCard,
  JoinRequestCreatedNotificationCard,
  InvitationCreatedNotificationCard,
  InvitationDecidedNotificationCard,
  InvitationCancelledNotificationCard,
  TeamInvitationCreatedNotificationCard,
  TeamInvitationDecidedNotificationCard,
  TeamInvitationCancelledNotificationCard,
  ProjectTeamRemovedNotificationCard,
  TeamSubscriptionCreatedNotificationCard,
  TeamSubscriptionDeletedNotificationCard,
  TeamMemberLeftNotificationCard,
  TeamMemberRemovedNotificationCard,
  TeamMemberRemovedBroadcastNotificationCard,
  TeamJoinRequestCreatedNotificationCard,
  TeamJoinRequestDecidedNotificationCard,
  TeamJoinRequestCanceledNotificationCard,
  TeamCatalogInvitationCreatedNotificationCard,
  TeamCatalogInvitationDecidedNotificationCard,
  TeamCatalogInvitationCancelledNotificationCard,
  ProjectJoinRequestCanceledNotificationCard,
  ProjectLikeSummaryNotificationCard,
  ProjectCommentNotificationCard,
  ProjectSubscriptionDeletedNotificationCard,
  ProjectAdminGrantedNotificationCard,
  ProjectAdminRevokedNotificationCard,
  ProjectTeamSpaceChangedNotificationCard,
  TeamAdminGrantedNotificationCard,
  TeamAdminRevokedNotificationCard,
  ProjectRestrictionAppliedNotificationCard,
  ProjectRestrictionRemovedNotificationCard,
  ProjectMemberRemovedNotificationCard,
  JoinRequestDecidedNotificationCard,
  SubscriptionCreatedNotificationCard,
  UserFollowedAuthorNotificationCard,
  SocialOrderCompletionChangedNotificationCard,
  SocialOrderLinkedProjectCreatedNotificationCard,
  SocialOrderCommentNotificationCard,
  SocialOrderLikeSummaryNotificationCard,
  SocialOrderSubscriptionCreatedNotificationCard,
  SocialOrderSubscriptionDeletedNotificationCard,
  SocialOrderRestrictionAppliedNotificationCard,
  SocialOrderRestrictionRemovedNotificationCard,
  GrowthToolRestrictionAppliedNotificationCard,
  GrowthToolRestrictionRemovedNotificationCard,
} from '../NotificationCards'

type Props = {
  notification: NotificationResource
}

export const EventItem = ({ notification }: Props) => {
  switch (notification.type) {
    case 'project.join_request.created':
      return (
        <JoinRequestCreatedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.join_request.created' }>}
        />
      )
    case 'project.join_request.decided':
      return (
        <JoinRequestDecidedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.join_request.decided' }>}
        />
      )
    case 'project.join_request.canceled':
      return (
        <ProjectJoinRequestCanceledNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.join_request.canceled' }>}
        />
      )
    case 'project.invitation.created':
      return (
        <InvitationCreatedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.invitation.created' }>}
        />
      )
    case 'project.invitation.decided':
      return (
        <InvitationDecidedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.invitation.decided' }>}
        />
      )
    case 'project.invitation.cancelled':
      return (
        <InvitationCancelledNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.invitation.cancelled' }>}
        />
      )
    case 'project.team_invitation.created':
      return (
        <TeamInvitationCreatedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'project.team_invitation.created' }>
          }
        />
      )
    case 'project.team_invitation.decided':
      return (
        <TeamInvitationDecidedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'project.team_invitation.decided' }>
          }
        />
      )
    case 'project.team_invitation.cancelled':
      return (
        <TeamInvitationCancelledNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'project.team_invitation.cancelled' }>
          }
        />
      )
    case 'project.team.removed':
      return (
        <ProjectTeamRemovedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.team.removed' }>}
        />
      )
    case 'project.subscription.created':
      return (
        <SubscriptionCreatedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.subscription.created' }>}
        />
      )
    case 'project.subscription.deleted':
      return (
        <ProjectSubscriptionDeletedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.subscription.deleted' }>}
        />
      )
    case 'team.subscription.created':
      return (
        <TeamSubscriptionCreatedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.subscription.created' }>}
        />
      )
    case 'team.subscription.deleted':
      return (
        <TeamSubscriptionDeletedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.subscription.deleted' }>}
        />
      )
    case 'team.member.left':
      return (
        <TeamMemberLeftNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.member.left' }>}
        />
      )
    case 'team.member.removed':
      return (
        <TeamMemberRemovedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.member.removed' }>}
        />
      )
    case 'team.member.removed.broadcast':
      return (
        <TeamMemberRemovedBroadcastNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'team.member.removed.broadcast' }>
          }
        />
      )
    case 'team.join_request.created':
      return (
        <TeamJoinRequestCreatedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.join_request.created' }>}
        />
      )
    case 'team.join_request.decided':
      return (
        <TeamJoinRequestDecidedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.join_request.decided' }>}
        />
      )
    case 'team.join_request.canceled':
      return (
        <TeamJoinRequestCanceledNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.join_request.canceled' }>}
        />
      )
    case 'team.invitation.created':
      return (
        <TeamCatalogInvitationCreatedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.invitation.created' }>}
        />
      )
    case 'team.invitation.decided':
      return (
        <TeamCatalogInvitationDecidedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.invitation.decided' }>}
        />
      )
    case 'team.invitation.cancelled':
      return (
        <TeamCatalogInvitationCancelledNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.invitation.cancelled' }>}
        />
      )
    case 'team.admin.granted':
      return (
        <TeamAdminGrantedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.admin.granted' }>}
        />
      )
    case 'team.admin.revoked':
      return (
        <TeamAdminRevokedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'team.admin.revoked' }>}
        />
      )
    case 'project.admin.granted':
      return (
        <ProjectAdminGrantedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.admin.granted' }>}
        />
      )
    case 'project.admin.revoked':
      return (
        <ProjectAdminRevokedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.admin.revoked' }>}
        />
      )
    case 'project.team_space.changed':
      return (
        <ProjectTeamSpaceChangedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.team_space.changed' }>}
        />
      )
    case 'project.restriction.applied':
      return (
        <ProjectRestrictionAppliedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.restriction.applied' }>}
        />
      )
    case 'project.restriction.removed':
      return (
        <ProjectRestrictionRemovedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.restriction.removed' }>}
        />
      )
    case 'project.member.removed':
      return (
        <ProjectMemberRemovedNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.member.removed' }>}
        />
      )
    case 'project.like.summary':
      return (
        <ProjectLikeSummaryNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'project.like.summary' }>}
        />
      )
    case 'user_followed_author':
      return (
        <UserFollowedAuthorNotificationCard
          notification={notification as Extract<KnownNotificationResource, { type: 'user_followed_author' }>}
        />
      )
    case 'user_followed_author_project_published':
      return (
        <FollowedAuthorProjectPublishedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'user_followed_author_project_published' }>
          }
        />
      )
    case 'user_followed_author_project_status_changed':
      return (
        <FollowedAuthorProjectStatusChangedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'user_followed_author_project_status_changed' }>
          }
        />
      )
    case 'user_followed_author_project_recruitment_opened':
      return (
        <FollowedAuthorProjectRecruitmentOpenedNotificationCard
          notification={
            notification as Extract<
              KnownNotificationResource,
              { type: 'user_followed_author_project_recruitment_opened' }
            >
          }
        />
      )
    case 'user_followed_author_project_recruitment_updated':
      return (
        <FollowedAuthorProjectRecruitmentUpdatedNotificationCard
          notification={
            notification as Extract<
              KnownNotificationResource,
              { type: 'user_followed_author_project_recruitment_updated' }
            >
          }
        />
      )
    case 'social_order.completion.changed':
      return (
        <SocialOrderCompletionChangedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'social_order.completion.changed' }>
          }
        />
      )
    case 'social_order.linked_project.created':
    case 'social_order.linked_project.created.author':
      return (
        <SocialOrderLinkedProjectCreatedNotificationCard
          notification={
            notification as Extract<
              KnownNotificationResource,
              { type: 'social_order.linked_project.created' | 'social_order.linked_project.created.author' }
            >
          }
        />
      )
    case 'social_order.like.summary':
      return (
        <SocialOrderLikeSummaryNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'social_order.like.summary' }>
          }
        />
      )
    case 'social_order.subscription.created':
      return (
        <SocialOrderSubscriptionCreatedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'social_order.subscription.created' }>
          }
        />
      )
    case 'social_order.subscription.deleted':
      return (
        <SocialOrderSubscriptionDeletedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'social_order.subscription.deleted' }>
          }
        />
      )
    case 'social_order.restriction.applied':
      return (
        <SocialOrderRestrictionAppliedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'social_order.restriction.applied' }>
          }
        />
      )
    case 'social_order.restriction.removed':
      return (
        <SocialOrderRestrictionRemovedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'social_order.restriction.removed' }>
          }
        />
      )
    case 'growth_tool.restriction.applied':
      return (
        <GrowthToolRestrictionAppliedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'growth_tool.restriction.applied' }>
          }
        />
      )
    case 'growth_tool.restriction.removed':
      return (
        <GrowthToolRestrictionRemovedNotificationCard
          notification={
            notification as Extract<KnownNotificationResource, { type: 'growth_tool.restriction.removed' }>
          }
        />
      )
    case 'social_order.comment.created':
    case 'social_order.comment.replied':
    case 'social_order.comment.liked':
      return (
        <SocialOrderCommentNotificationCard
          notification={notification as SocialOrderCommentNotificationResource}
        />
      )
    case 'project.comment.created':
    case 'project.comment.replied':
    case 'project.comment.liked':
      return <ProjectCommentNotificationCard notification={notification as ProjectCommentNotificationResource} />
    default:
      return <FallbackNotificationCard notification={notification} />
  }
}
